import React from 'react'

const SvgChatViewFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.01 2.013a2 2 0 012 2v4.07a7.06 7.06 0 00-1-.07c-1.211 0-2.35.307-3.343.848a1 1 0 10-.346.202 7.006 7.006 0 00-3.194 4.664H5.01l-3 3.082V4.013a2 2 0 012-2h10zM7.001 9.114a1 1 0 100-2 1 1 0 000 2z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.01 10.013a5 5 0 014.178 7.747l.095.095 2.482 2.493c.393.447.244 1.013-.087 1.342-.33.328-.896.469-1.316.054l-.043-.044-2.533-2.528a5 5 0 11-2.777-9.159zm0 2a3 3 0 100 6 3 3 0 000-6z'
    />
  </svg>
)

export default SvgChatViewFilled
